import { LeadsDataConstant } from "./LeadsContant";

const LeadsAction = {};

LeadsAction.getLeadsAction = ({
  page,
  limit,
  search_term,
  from_date,
  to_date,
} = {}) => ({
  type: LeadsDataConstant.LEADS_DATA_SAGA,
  payload: {
    page:page,
    limit:limit,
    from_date: from_date,
    to_date: to_date,
    search_term:search_term
  },
});


export { LeadsAction };
